define(
    'postLogin/pollSession',[
        'durandal/app', 'plugins/router', 'knockout', 'lodash', 'atn/atn',
        'dataSource/apiCallPollingInterface', './logout', 'checkPreInit/index'
    ],
    function(app, router, ko, _, atn, apiCallPollingInterface, logout, checkPreInit) {
        'use strict';
        var retrying = ko.observable(false),
            retryPopup = ko.observable(false),
            notRespondingPopup = atn.config.messages.sessionPolling.notResponding,
            logoutPopup = atn.config.messages.sessionPolling.logout,
            statusAction = {
                '403': checkApiVersion,
                '404': checkApiVersion,
                '400': askForLogout,
                'other': retry
            };
            
        var pollingAjaxSettings = {
            url: atn.config.api.sessionData + '?current_timestamp=' + Date.now(),
            type: 'GET',
            dataType: 'json',
            global: false
        };

        var pollingInterval = 60;

        var sessionPoller = apiCallPollingInterface.createPolling(onFailedPoll, onSuccessPoll, pollingAjaxSettings, pollingInterval);

        atn.isLoggedOut.subscribe(watchLoginStatus);
        //  making sure to be called once
        watchLoginStatus(atn.isLoggedOut());

        return {
            retrying: retrying,
            retryPopup: retryPopup
        };

        function onSuccessPoll() {
            //  stopping loading
            retrying(false);
        }

        function onFailedPoll(xhr) {
            //  stopping loading
            retrying(false);
            if (!xhr.readyState) {
                statusAction.other();
            } else if (_.isFunction(statusAction[String(xhr.status)])) {
                statusAction[String(xhr.status)]();
            } else {
                statusAction.other();
            }
        }

        function askForLogout() {
            app.atnCustomDialog(logoutPopup.text, logoutPopup.heading, ['OK']).always(logout.thisServiceLogout());
        }

        function retry() {
            sessionPoller.stop();
            retryPopup(true);
            app.atnCustomDialog(notRespondingPopup.text, notRespondingPopup.heading, ['Retry']).always(function() {
                retryPopup(false);
                retrying(true);
                if (!atn.isLoggedOut.peek()) {
                    sessionPoller.start();
                }
            });
        }

        function checkApiVersion() {
            var data = {};
            checkPreInit.loginStaircase(checkPreInit.onInit(data, function() {
                _.defer(router.navigate, data.fragment || '#site/logout');
            }));
        }

        function watchLoginStatus(isLoggedOut) {
            if (isLoggedOut) {
                sessionPoller.stop();
            } else {
                sessionPoller.start();
            }
        }
    });
